import * as React from 'react';
import { connect } from "react-redux";
import { useState, useEffect, useRef } from 'react';
import { Text, View, ScrollView, RefreshControl, Dimensions, StyleSheet } from 'react-native'
import { useIsFocused, useNavigation } from '@react-navigation/native';
import { ActivityIndicator, Appbar, Button, Card, Checkbox, DataTable, Divider, Drawer, IconButton, Menu, Modal, Portal, TextInput } from 'react-native-paper';
import { TabScreen, Tabs } from 'react-native-paper-tabs';
import { getPayouts, setPayouts } from '../../../app/store/actions/superActions';
import AppBar from '../../../AppBar';
import globalStyles from '../../../app/components/Styles';
import moment from 'moment';
import AlertDialog from '../../../app/components/AlertDialog';
import { getAcademies, getCoaches } from '../../../app/store/actions/userActions';
import DropDown from 'react-native-paper-dropdown';
import { CameraView, useCameraPermissions } from 'expo-camera';
import QrReader from "modern-react-qr-reader"

export const Payouts = ({ token, user, isLoading, payouts, coaches, academies, getCoaches, getAcademies, getPayouts, setPayouts }) => {

    const navigation = useNavigation();
    const screenWidth = Dimensions.get('screen').width;
    const [visible, setVisible] = React.useState(false);
    const showModal = () => setVisible(true);
    const hideModal = () => setVisible(false);
    const containerStyle = { backgroundColor: 'white', width: (screenWidth - 50), height: (screenWidth - 50), margin: 30, justifyContent: "center", alignItems: "center", borderRadius: 10 };

    const [attendanceIds, setAttendanceIds] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);

    const handleCheckboxToggle = (rowId, amount) => {
        // Check if the rowId is already in the selectedRows array
        if (attendanceIds.includes(rowId)) {
            // If yes, remove it and subtract the amount
            setAttendanceIds((prevSelectedRows) => prevSelectedRows.filter(id => id !== rowId));
            setTotalAmount((prevTotalAmount) => prevTotalAmount - amount);
        } else {
            // If not, add it and add the amount
            setAttendanceIds((prevSelectedRows) => [...prevSelectedRows, rowId]);
            setTotalAmount((prevTotalAmount) => prevTotalAmount + amount);
        }
    };

    const [filters, setFilters] = useState({
        coachId: undefined,
        academyId: undefined
    })

    const [tempFilters, setTempFilters] = useState({
        coachId: undefined,
        academyId: undefined
    })

    const [acceptAlert, setAcceptAlert] = useState({
        visible: false,
    })

    const handleOpenAcceptAlert = () => {
        setAcceptAlert({
            visible: true,
        })
    }

    const handleCloseAlert = () => {
        setAcceptAlert({
            visible: false,
        })
    }

    const handleAcceptPayment = () => {
        setPayouts({ attendanceIds })
        handleCloseAlert()
        refresher()
    }

    const [filter, setFilter] = React.useState(false)
    const [menuVisible, setMenuVisible] = React.useState(false);

    const openMenu = () => {
        setMenuVisible(true)
    };

    const closeMenu = () => {
        setMenuVisible(false)
    };

    const openFilter = () => {
        setFilter(true)
    }

    const closeFilter = () => {
        setFilter(false)
    }

    const [showDropDown, setShowDropDown] = useState(false)
    const openDropDown = () => {
        setShowDropDown(true)
    }

    const closeDropDown = () => {
        setShowDropDown(false)
    }

    const [showDropDown1, setShowDropDown1] = useState(false)
    const openDropDown1 = () => {
        setShowDropDown1(true)
    }

    const closeDropDown1 = () => {
        setShowDropDown1(false)
    }

    const handleChangeFilter = (val, name) => {
        setTempFilters({ ...tempFilters, [name]: val })
    }

    const handleApplyFilter = () => {
        setFilters({
            ...filters,
            ...tempFilters
        })
    }

    const handleClearFilter = () => {
        setFilters({
            coachId: undefined,
            accademyId: undefined
        })
    }

    const refresher = async () => {
        getPayouts(filters)
        console.log(payouts)
    }

    useEffect(() => {
        refresher()
    }, [user, filters])

    useEffect(() => {
        getAcademies({ page: 1, limit: 500, title: "" })
        getCoaches({ page: 1, limit: 500, name: "" })
    }, [])

    const [scanned, setScanned] = useState(false);
    const [permission, requestPermission] = useCameraPermissions();

    const handleBarCodeScanned = (data) => {
        if (data) {
            setFilters({ ...filters, coachId: data });
            hideModal();
        }
    };


    if (isLoading) {
        return (
            <View style={globalStyles.container}>
                <ActivityIndicator />
            </View>
        )
    }

    return (
        <ScrollView refreshControl={<RefreshControl onRefresh={refresher} />}>
            <AppBar navigation={navigation} title={"Payouts"} action={<>
                <Appbar.Action icon="qrcode-scan" onPress={showModal} />
                <Menu
                    visible={menuVisible}
                    onDismiss={closeMenu}
                    style={{ width: 300 }}
                    anchor={<Appbar.Action icon="menu" id="menu" onPress={openMenu} />}>
                    <Menu.Item onPress={() => { navigation.navigate("CreateAcademy"); closeMenu() }} leadingIcon="plus-circle" title="Create Academy" />
                    <Menu.Item onPress={() => { navigation.navigate("CreateCoach"); closeMenu() }} leadingIcon="plus-circle" title="Create Coach" />
                    <Menu.Item onPress={() => { navigation.navigate("Coaches"); closeMenu() }} leadingIcon="whistle" title="View Coaches" />
                    <Menu.Item onPress={() => { navigation.navigate("Payouts"); closeMenu() }} leadingIcon="receipt" title="View Payments" />
                    <Menu.Item onPress={() => { navigation.navigate("Payouts"); closeMenu() }} leadingIcon="cash-fast" title="View Payouts" />
                </Menu>
                <Menu
                    visible={filter}
                    onDismiss={closeFilter}
                    style={{ width: 300 }}
                    anchor={<Appbar.Action icon="filter-outline" id="filter-menu" onPress={openFilter} />}>

                    <DropDown
                        dropDownItemTextStyle={{ color: "whitesmoke" }}
                        dropDownItemSelectedTextStyle={{ fontWeight: "bold", color: "white" }}
                        label={"Coach"}
                        mode={"outlined"}
                        visible={showDropDown}
                        dropDownStyle={{ marginVertical: 4, marginHorizontal: 5 }}
                        showDropDown={openDropDown}
                        onDismiss={closeDropDown}
                        value={tempFilters.coachId}
                        setValue={(val) => handleChangeFilter(val, "coachId")}
                        list={coaches?.map((coach) => {
                            return {
                                label: coach.name, value: coach._id
                            }
                        })}
                    />

                    <DropDown
                        dropDownItemTextStyle={{ color: "whitesmoke" }}
                        dropDownItemSelectedTextStyle={{ fontWeight: "bold", color: "white" }}
                        label={"Academy"}
                        mode={"outlined"}
                        visible={showDropDown1}
                        dropDownStyle={{ marginVertical: 4, marginHorizontal: 5 }}
                        showDropDown={openDropDown1}
                        onDismiss={closeDropDown1}
                        value={tempFilters.academyId}
                        setValue={(val) => handleChangeFilter(val, "academyId")}
                        list={academies?.map((academy) => {
                            return {
                                label: academy.title, value: academy._id
                            }
                        })}
                    />
                    <Divider />
                    <Button onPress={handleApplyFilter}>Apply Filters</Button>
                    <Button onPress={handleClearFilter}>Clear Filters</Button>
                </Menu>
            </>} />
            <View style={globalStyles.container}>
                <View>
                    <Portal>
                        <Modal visible={visible} onDismiss={hideModal} contentContainerStyle={containerStyle}>
                            <View style={{ ...globalStyles.container, width: "100%" }}>
                                <Text style={{ fontWeight: "bold", fontSize: 15, marginBottom: 10 }}>Scan Coach QR-Code to get their payout</Text>
                                {permission?.granted && <View style={styles.container}>
                                    <QrReader
                                        onScan={(data) => scanned ? null : handleBarCodeScanned(data)}
                                        style={{
                                            height: 240,
                                            width: "100%",
                                        }}
                                    />
                                </View>}
                                {!permission?.granted && (
                                    <View>
                                        <Text style={{ textAlign: 'center' }}>We need your permission to show the camera</Text>
                                        <Button mode="contained" style={{ marginTop: 10 }} onPress={requestPermission}> Grant Permission</Button>
                                    </View>
                                )}
                            </View>
                        </Modal>
                    </Portal>
                </View>
                <DataTable style={globalStyles.table}>
                    <DataTable.Header style={globalStyles.header}>
                        <DataTable.Title style={{ flex: 2 }}>Select</DataTable.Title>
                        <DataTable.Title style={{ flex: 2 }}>Academy</DataTable.Title>
                        <DataTable.Title style={{ flex: 2 }}>Coach</DataTable.Title>
                        <DataTable.Title style={{ flex: 2 }}>Amount</DataTable.Title>
                    </DataTable.Header>

                    {payouts?.map((payout) => (
                        <DataTable.Row>
                            <DataTable.Cell style={{ flex: 2 }}>
                                <Checkbox
                                    status={attendanceIds.includes(payout._id) ? 'checked' : 'unchecked'}
                                    onPress={() => handleCheckboxToggle(payout._id, payout.coach.salary)}
                                />
                            </DataTable.Cell>
                            <DataTable.Cell style={{ flex: 2 }}><Text>{payout.academy.title}</Text></DataTable.Cell>
                            <DataTable.Cell style={{ flex: 2 }}><Text>{coaches.filter((coach) => coach.coach._id === payout.coach._id)[0].name}</Text></DataTable.Cell>
                            <DataTable.Cell style={{ flex: 2 }}><Text>{payout.coach.salary} EGP</Text></DataTable.Cell>
                        </DataTable.Row>
                    ))}

                </DataTable>
                {filters.userId && <Button style={{ marginVertical: 10 }} mode="contained" onPress={handleClearFilter}>Clear User Filter</Button>}
                {totalAmount > 0 && <Button style={{ marginVertical: 10 }} mode="contained" onPress={handleOpenAcceptAlert}>Confirm Payment</Button>}
                <AlertDialog visible={acceptAlert.visible} message={`Confirm payment of ${totalAmount}EGP`} okText={"ACCEPT"} handleAccept={handleAcceptPayment} handleClose={handleCloseAlert} />
            </View>
        </ScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
    },
    buttonContainer: {
        flex: 1,
        flexDirection: 'row',
        backgroundColor: 'transparent',
        margin: 150,
    }
});

const mapStateToProps = (state) => ({
    token: state?.auth?.token,
    user: state.auth?.user,
    academies: state?.records?.academies?.docs,
    coaches: state?.records?.coaches?.docs,
    payouts: state?.records?.payouts,
    isLoading: state?.records?.isLoading
});

const mapDispatchToProps = {
    getPayouts, getAcademies, setPayouts, getCoaches
};

export default connect(mapStateToProps, mapDispatchToProps)(Payouts);